import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import type {IconModel} from '@/types/aem';
import {twx} from '@/utils/tailwindUtils';

interface AutoDeliveryDcxIconListProps {
    title?: string;
    items?: IconModel[];
    className?: string;
}

const AutoDeliveryDcxIconList = (props: AutoDeliveryDcxIconListProps) => {
    const {title, items, className} = props;

    if (!title && !items?.length) return null;

    return (
        <article className={twx('flex flex-col gap-4', className)}>
            {title && (
                <h2 className='mb-0 text-20 font-bold leading-[28px] tracking-[0.2px] ml:text-24 ml:leading-[36px] ml:tracking-normal'>
                    {title}
                </h2>
            )}
            <ul className='flex w-full flex-col gap-4 rounded-xl bg-primary-dark-5 p-4 md:flex-1'>
                {items?.map((item) => {
                    const {title: itemTitle, description} = item;

                    return (
                        <li
                            key={itemTitle}
                            className={twx(
                                'grid grid-cols-[48px_1fr] items-center text-16 leading-15',
                                description ? 'gap-x-4' : 'gap-x-2'
                            )}
                        >
                            <div
                                className={twx('h-auto w-full shrink-0', {
                                    'row-span-2': itemTitle && description,
                                })}
                            >
                                <RemoteIconV2 icon={item} className='size-12' />
                            </div>
                            {itemTitle && (
                                <p
                                    className={twx(
                                        'content-center text-14 leading-[20px] tracking-[0.2px]',
                                        description ? 'font-bold' : 'row-span-2'
                                    )}
                                >
                                    {itemTitle}
                                </p>
                            )}
                            {description && (
                                <p
                                    className={twx('text-14 leading-[20px] tracking-[0.4px]', {
                                        'row-span-2 content-center': !itemTitle,
                                    })}
                                >
                                    {description}
                                </p>
                            )}
                        </li>
                    );
                })}
            </ul>
        </article>
    );
};

export default AutoDeliveryDcxIconList;
